import { BrowserRouter, Routes, Route } from "react-router-dom";
import VerifyCertificate from "./pages/VerifyCertificate";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AddCertificate from "./pages/AddCertificate";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/verify/:id" element={<VerifyCertificate />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/add-certificate" element={<AddCertificate />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
